module.exports = __webpack_public_path__ + "static/media/retornavel-mobile.10279e3c.jpg";